<template>
  <li>
    <div class="pull-right profile-section">
      <div class="tbs-profile" :class="{ 'tbs-profile--visible': expanded === '_profile' }">
        <div class="tbs-profile__icon">
          <div class="v-ctr">
            <button
              v-if="isAuthenticated"
              class="btn profile-button btn-icon btn-clean"
              aria-haspopup="true"
              :aria-expanded="expanded === '_profile' ? 'true' : 'false'"
              :aria-label="$t('common.aria_label_text_profile')"
              @click="onToggle"
            >
              <span v-if="computedFirstname" class="button-text">
                {{ computedFirstname }}
                <!-- #D413 -->
              </span>
              <VSvgIcon name="my-profile" variant="outlined" />
            </button>
            <VButton v-else class="btn btn-brand" label="common.headerLogin" @click="onLogin" />
          </div>
        </div>
        <div v-if="expanded === '_profile'" class="tbs-profile__content">
          <VueFocusLock>
            <div class="profile-render">
              <h5 v-if="computedDisplayname">
                {{ computedDisplayname }}
                <!-- #D414 -->
              </h5>
              <p v-if="email" class="text-small mail">
                {{ email }}
                <!-- #D415 -->
              </p>
            </div>
            <ul class="profile-links">
              <li v-if="firstExternalLoginStatusCallerUrl && !username">
                <a data-test="profile-link1" :href="firstExternalLoginStatusCallerUrl" class="text-small">
                  {{ $t('common.navigation_login_status_caller_first_hyperlink_label') }}
                  <!-- #S664 + I258 -->
                </a>
              </li>
              <li v-if="secondExternalLoginStatusCallerUrl && !username">
                <a data-test="profile-link2" :href="secondExternalLoginStatusCallerUrl" class="text-small">
                  {{ $t('common.navigation_login_status_caller_second_hyperlink_label') }}
                  <!-- #S665 + I259 -->
                </a>
              </li>
              <li v-if="hasShowTechnicalInformation">
                <router-link :to="{ name: PROFILE }" class="text-small" data-test="profile">
                  <!-- #S666 +I260 -->
                  {{ $t('common.navigation_login_status_caller_profile_hyperlink_label') }}
                </router-link>
              </li>
              <li v-if="isAuthTypeLogin">
                <router-link v-if="computedShowPasswordChangeForm" :to="{ name: PASSWORD }" class="text-small" data-test="password-change-form-internal-link">
                  {{ $t('common.navigation_login_status_caller_password_hyperlink_label') }}
                </router-link>
                <a v-else :href="externalPasswordChangeUrl" class="text-small" data-test="password-change-form-external-link">
                  {{ $t('common.navigation_login_status_caller_password_hyperlink_label') }}
                </a>
              </li>
            </ul>
            <div class="logout-section">
              <a name="logout:logout" data-test="logout" href="#" class="btn btn-white" @click.prevent="onLogout">
                <span>
                  {{ $t('common.profile_logout_button_label') }}
                  <!-- #S410 + I151 -->
                </span>
              </a>
            </div>
          </VueFocusLock>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VueFocusLock from 'vue-focus-lock';
import { PROFILE, PASSWORD } from '@route-types';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
export default {
  name: 'LoginStatusCaller',

  components: {
    VSvgIcon,
    VueFocusLock,
    VButton: () => import('@/components/Button'),
  },

  props: {
    expanded: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      PROFILE,
      PASSWORD,
    };
  },

  computed: {
    ...mapState('system', [
      'firstExternalLoginStatusCallerUrl',
      'secondExternalLoginStatusCallerUrl',
      'username',
      'firstname',
      'displayname',
      'email',
      'externalPasswordChangeUrl',
    ]),

    ...mapGetters('system', ['hasShowTechnicalInformation', 'isAuthenticated', 'isAuthTypeLogin', 'showPasswordChangeForm']),

    computedFirstname() {
      return this.firstname || this.username;
    },

    computedDisplayname() {
      return this.displayname || this.username;
    },

    computedShowPasswordChangeForm() {
      return this.showPasswordChangeForm;
    },
  },

  methods: {
    onLogin() {
      this.$store.dispatch('system/loginOpenId');
    },

    onToggle() {
      if (this.expanded === '_profile') {
        this.$emit('update:expanded', '_closed');
        this.$nextTick(() => {
          this.previousElement.focus();
        });
      } else {
        this.$emit('update:expanded', '_profile');
        this.previousElement = document.previousElement;
      }
    },

    onLogout() {
      this.$store.dispatch('system/logout');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

ul.profile-links {
  padding-left: 0;
  margin: 0;
  list-style: none;
}

ul.profile-links li {
  margin-bottom: 9px;
}

.tbs-profile {
  position: relative;
}

.tbs-profile__content {
  position: absolute;
  top: 60px;
  right: 0;
  z-index: 10;
  display: none;
  min-width: 208px;
  max-width: 296px;
  padding: 30px 24px 36px 30px;
  background: $modal-content-bgr;
  box-shadow: 2px 3px 9px rgba(117, 117, 117, 0.41);
}

.tbs-profile--visible .tbs-profile__content {
  display: block;
}

.tbs-profile__content a {
  display: block;
}

.tbs-profile__content .profile-render {
  padding-bottom: 24px;
  overflow: hidden;
  white-space: nowrap;
}

.tbs-profile__content .profile-links a:not(:last-child) {
  margin-bottom: 9px;
}

.tbs-profile__content .logout-section {
  padding-top: 30px;
}

.tbs-profile__content .logout-section .btn.btn-white,
.tbs-profile__content .logout-section .btn.btn-white:active,
.tbs-profile__content .logout-section .btn.btn-white:focus,
.tbs-profile__content .logout-section .btn.btn-white:hover {
  display: inline-block;
  width: auto;
  padding: 5px 15px;
  margin: 0;
}

.profile-button {
  height: 36px;
  padding: 1px 5px 4px;
}

.tbs-profile--visible .profile-button,
.profile-button:hover,
.profile-button.btn.btn-clean:focus:focus,
.profile-button:active {
  background-color: $color-element-background;
}

.profile-button .button-text {
  position: relative;
  top: 4px;
  display: inline-block;
  max-width: 96px;
  padding-left: 6px;
  overflow: hidden;
  color: $color-gray;
  text-overflow: ellipsis;
}

@media screen and (max-width: #{$grid-medium-max}px) {
  .profile-button .button-text {
    display: none;
  }
}

.profile-button .button-text,
.profile-button .icon {
  float: right;
}

h5 {
  padding-bottom: 0;
}

.mail {
  padding-top: 1px;
  color: $color-gray;
}
</style>
